export default "__VITE_ASSET__ZwXM2QSf__"